import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Helmet from 'react-helmet';

import Textlink from '@xingternal/malt-textlink';
import { Row, Column } from '@xingternal/malt-grid';

import PageviewTracker from '../../Components/PageviewTracker/PageviewTracker';
import Spacer from './../../Components/Spacer/Spacer';
import { CustomH, CustomP } from './../../Components/CustomMalt/Typography';

import messages from './messages';
import styles from './Logout.css';

import SurveyForm from './SurveyForm';

const buildLink = (to, message) => (
  <Textlink testId={'login-again-link'} to={to}>
    <FormattedMessage {...message} />
  </Textlink>
);

export const timeToGreetingKey = () => {
  const now = new Date();
  const greetingsDictionary = [
    {
      hours: [2, 3, 4, 5, 6, 7, 8],
      messageKey: 'morningHeadline',
    },
    {
      hours: [9, 10, 11, 12, 13, 14, 15, 16, 17],
      messageKey: 'dayHeadline',
    },
    {
      hours: [18, 19, 20, 21, 22, 23, 0, 1],
      messageKey: 'nightHeadline',
    },
  ];

  const { messageKey } = greetingsDictionary.find(({ hours }) =>
    hours.includes(now.getHours())
  );

  return messageKey;
};

const Logout = ({ intl }) => {
  return (
    <>
      <Helmet title={intl.formatMessage(messages.metaTitle)} />
      <PageviewTracker pageName={'wbm/Welcome/logout'} />
      <Spacer size={8} />
      <Row style={{ minHeight: '75vh' }}>
        <Column size={12} className={styles.centerChildren}>
          <CustomH>
            <FormattedMessage {...messages[timeToGreetingKey()]} />
          </CustomH>
          <CustomP>
            <FormattedMessage
              {...messages.comeback}
              values={{
                loginLink: buildLink('/', messages.loginLinkText),
              }}
            />
          </CustomP>
          <SurveyForm />
        </Column>
      </Row>
    </>
  );
};

export default injectIntl(Logout);
